import { useSelector } from "react-redux";
import RootState from "src/features/redux/types/rootState.types";

export default function useAuth() {
  return useSelector((state: RootState) => state.auth);
}
